import "../../../../assets/scss/components/sections/home/before-and-after.scss";
import { Col, Image, Row } from "react-bootstrap";
import data from "./example_data.json";
import { useState, useRef } from "react";

import leftScroll from "../../../../assets/images/home/left-scroll.svg";
import rightScroll from "../../../../assets/images/home/right-scroll.svg";

import Slider from "react-slick";

const BeforeAndAfterSimple = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const jobTitlesRef = useRef(null);
    const [beforeOrAfter, setBeforeOrAfter] = useState("Before");
    const sliderRef = useRef(null);

    const sliderSettings = {
        className: "slider variable-width",
        dots: false,
        infinite: true,
        speed: 500,
        slidesToScroll: 1,
        variableWidth: true,
        afterChange: (current) => {
            setCurrentIndex(current); // Update currentIndex when slider changes
        },
        responsive: [
            {
                breakpoint: 573,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    const handlePrevClick = () => {
        sliderRef.current.slickPrev();
        const newIndex =
            (currentIndex - 1 + data.resumes.length) % data.resumes.length;
        setCurrentIndex(newIndex);
    };

    const handleNextClick = () => {
        sliderRef.current.slickNext();
        const newIndex = (currentIndex + 1) % data.resumes.length;
        setCurrentIndex(newIndex);
    };

    return (
        <div className="before-and-after-section" id="examples">
            <div className="container">
                <div className="before-and-after">
                    <h1 className="heading-1">How we improve your resume</h1>

                    <div className="job-titles-wrapper">
                        <button className="nav-arrow left-arrow" onClick={handlePrevClick}>
                            <Image src={leftScroll} />
                        </button>
                        <div className="job-titles" ref={jobTitlesRef}>
                            <Slider {...sliderSettings} ref={sliderRef}>
                                {data.resumes.map((job, index) => (
                                    <button
                                        key={index}
                                        className={`job-button ${currentIndex === index ? "active" : ""}`}
                                        onClick={() => setCurrentIndex(index)}
                                    >
                                        {job.job_title}
                                    </button>
                                ))}
                            </Slider>
                        </div>
                        <button className="nav-arrow right-arrow" onClick={handleNextClick}>
                            <Image src={rightScroll} />
                        </button>
                    </div>

                    <div className="toggle-buttons d-lg-none">
                        <div className="toggle">
                            <button
                                className={`toggle-btn ${beforeOrAfter === "Before" ? "active" : ""}`}
                                onClick={() => setBeforeOrAfter("Before")}
                            >
                                Before
                            </button>
                            <button
                                className={`toggle-btn ${beforeOrAfter === "After" ? "active" : ""}`}
                                onClick={() => setBeforeOrAfter("After")}
                            >
                                After
                            </button>
                        </div>
                    </div>

                    <div className="content">
                        <Row className="align-items-stretch">
                            {/* Always show both columns on large screens */}
                            <Col lg={6} className="d-none d-lg-flex">
                                <h3 className="heading-5 text-center">Before</h3>
                                <div className="box">
                                    <div>
                                        <h6 className="heading-6">Key Skills</h6>
                                        <ul className="skills-list">
                                            {data.resumes[currentIndex].before.key_skills.map((skill, i) => (
                                                <li key={i} className="skills-item paragraph-small-regular">
                                                    {skill}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div>
                                        <h6 className="heading-6">Summary</h6>
                                        <ul className="summary-list">
                                            {data.resumes[currentIndex].before.summary.map((sentence, i) => (
                                                <li key={i} className="summary-list-item paragraph-small-regular">
                                                    {sentence}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>

                            {/* Toggle columns on smaller screens */}
                            <Col
                                lg={6}
                                className={`d-lg-none ${beforeOrAfter === "Before" ? "" : "d-none"}`}
                            >
                                <h3 className="heading-5 text-center">Before</h3>
                                <div className="box">
                                    <div>
                                        <h6 className="heading-6">Key Skills</h6>
                                        <ul className="skills-list">
                                            {data.resumes[currentIndex].before.key_skills.map((skill, i) => (
                                                <li key={i} className="skills-item paragraph-small-regular">
                                                    {skill}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div>
                                        <h6 className="heading-6">Summary</h6>
                                        <ul className="summary-list">
                                            {data.resumes[currentIndex].before.summary.map((sentence, i) => (
                                                <li key={i} className="summary-list-item paragraph-small-regular">
                                                    {sentence}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>

                            <Col lg={6} className="d-none d-lg-flex">
                                <h3 className="heading-5 text-center">After</h3>
                                <div className="box">
                                    <div>
                                        <h6 className="heading-6">Key Skills</h6>
                                        <ul className="skills-list">
                                            {data.resumes[currentIndex].after.key_skills.map((skill, i) => (
                                                <li key={i} className="skills-item paragraph-small-regular">
                                                    {skill}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div>
                                        <h6 className="heading-6">Summary</h6>
                                        <ul className="summary-list">
                                            {data.resumes[currentIndex].after.summary.map((sentence, i) => (
                                                <li key={i} className="summary-list-item paragraph-small-regular">
                                                    {sentence}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>

                            <Col
                                lg={6}
                                className={`d-lg-none ${beforeOrAfter === "After" ? "" : "d-none"}`}
                            >
                                <h3 className="heading-5 text-center">After</h3>
                                <div className="box">
                                    <div>
                                        <h6 className="heading-6">Key Skills</h6>
                                        <ul className="skills-list">
                                            {data.resumes[currentIndex].after.key_skills.map((skill, i) => (
                                                <li key={i} className="skills-item paragraph-small-regular">
                                                    {skill}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div>
                                        <h6 className="heading-6">Summary</h6>
                                        <ul className="summary-list">
                                            {data.resumes[currentIndex].after.summary.map((sentence, i) => (
                                                <li key={i} className="summary-list-item paragraph-small-regular">
                                                    {sentence}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BeforeAndAfterSimple;